<div style="padding:20px;">
  <ng-container *ngFor="let mes of Messages">
    <span>{{mes}}</span>
    <br />
  </ng-container>
</div>
